import { Currency, VolumeDiscountStep } from '@/types';
import { round } from '@/utils/math/round';

const getRoundToDecimals = (decimalCount: number) => (value: number) => round(value, decimalCount);

const getCurrentDiscount = (discounts: VolumeDiscountStep[], quantity: number) =>
  discounts.find(
    (d) => d.valueRange.from <= quantity && (!d.valueRange.to || d.valueRange.to >= quantity)
  );

const getNextDiscount = (discounts: VolumeDiscountStep[], quantity: number) =>
  discounts.find((d) => d.valueRange.from > quantity);

export function getDiscountBreakdown(
  product: number,
  totalQuantity: number,
  selectedQuantity: number,
  discounts: VolumeDiscountStep[],
  currency: Currency,
  productType: { discountSupported: boolean } = { discountSupported: true }
): DiscountBreakdown {
  const roundToDecimals = getRoundToDecimals(currency.decimalCount);
  const total = roundToDecimals(product * selectedQuantity);

  if (productType.discountSupported) {
    const currentDiscount = getCurrentDiscount(discounts, totalQuantity);
    const nextDiscount = getNextDiscount(discounts, totalQuantity);

    let reducedProduct: number | undefined;
    let reducedTotal: number | undefined;
    if (currentDiscount) {
      reducedProduct = roundToDecimals(product - (product * currentDiscount.credit.value) / 100);
      reducedTotal = roundToDecimals(reducedProduct * selectedQuantity);
    }

    return {
      product,
      total,
      reducedProduct,
      reducedTotal,
      currentDiscount: currentDiscount?.credit.value,
      nextDiscount: nextDiscount?.credit.value,
      nextDiscountFrom: nextDiscount?.valueRange.from,
    };
  }

  return {
    product,
    total,
  };
}
